enum EActionType {
	'withdraw' = 'withdraw',
	'deposit' = 'deposit',
}

export default EActionType;
